export const DROPDOWN_DIRECTION = 'bottom';

export const TEST_ID = 'mapDropdown';
